// Utilitários de data (datas locais no formato 'YYYY-MM-DD', sem UTC drift).

export function toISO(d: Date): string {
  const y = d.getFullYear()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const dia = String(d.getDate()).padStart(2, '0')
  return `${y}-${m}-${dia}`
}

export function hojeISO(): string {
  return toISO(new Date())
}

export function fromISO(iso: string): Date {
  const [y, m, d] = iso.split('-').map(Number)
  return new Date(y, m - 1, d)
}

export function addDias(iso: string, dias: number): string {
  const d = fromISO(iso)
  d.setDate(d.getDate() + dias)
  return toISO(d)
}

/** Segunda-feira da semana da data. */
export function inicioSemana(iso: string): string {
  const d = fromISO(iso)
  const dow = (d.getDay() + 6) % 7 // 0 = segunda
  d.setDate(d.getDate() - dow)
  return toISO(d)
}

export function inicioMes(iso: string): string {
  return iso.slice(0, 8) + '01'
}

export function fimMes(iso: string): string {
  const d = fromISO(inicioMes(iso))
  d.setMonth(d.getMonth() + 1)
  d.setDate(0)
  return toISO(d)
}

export function formatarData(iso: string): string {
  return iso.split('-').reverse().join('/')
}

export function formatarDataCurta(iso: string): string {
  const [, m, d] = iso.split('-')
  return `${d}/${m}`
}

export function formatarDataLonga(iso: string): string {
  return fromISO(iso).toLocaleDateString('pt-BR', { weekday: 'long', day: 'numeric', month: 'long' })
}

export function nomeMes(iso: string): string {
  return fromISO(iso).toLocaleDateString('pt-BR', { month: 'long', year: 'numeric' })
}

export function hora(h: string | null): string {
  return h ? h.slice(0, 5) : ''
}

export function calcularIdade(iso: string): number {
  const nasc = fromISO(iso)
  const hoje = new Date()
  let idade = hoje.getFullYear() - nasc.getFullYear()
  const aindaNaoFezAniversario =
    hoje.getMonth() < nasc.getMonth() ||
    (hoje.getMonth() === nasc.getMonth() && hoje.getDate() < nasc.getDate())
  if (aindaNaoFezAniversario) idade--
  return idade
}
